const localeEn = {
  en: {
    PAGE_TITLE: 'Experience it for 7 days',
    PAGE_DESCRIPTION: 'Complete your form to activate your free trial 🎉',

    TRIAL_FORM_TITLE: 'Experience it for 7 days',
    TRIAL_FORM_DESCRIPTION: 'Complete your form to activate your free trial',
    TRIAL_FORM_NAME: 'First Name',
    TRIAL_FORM_LAST_NAME: 'Last Name',
    TRIAL_FORM_PHONE: 'Phone Number',
    TRIAL_FORM_EMAIL: 'Corporate Email',
    TRIAL_FORM_ROLE: 'Position or Role',
    TRIAL_FORM_COMPANY: 'Company',
    TRIAL_FORM_ORGANIZATION_SIZE: 'Company Size',
    TRIAL_FORM_COUNTRY: 'Country',
    TRIAL_FORM_TERMS_1: 'By requesting the demo, I accept the',
    TRIAL_FORM_TERMS_2: 'terms and conditions',
    TRIAL_FORM_TERMS_3: 'of Crehana',
    TRIAL_FORM_SUBMIT_1: 'Sending...',
    TRIAL_FORM_SUBMIT_2: 'Submit Now',
    TRIAL_FORM_MAX_LENGTH_15: 'Maximum 15 characters',
    TRIAL_FORM_PHONE_PATTERN: 'Enter a valid phone number',
    TRIAL_FORM_EMAIL_PATTERN: 'Enter a valid email address',

    TRIAL_FORM_COUNTRY_1: 'Argentina',
    TRIAL_FORM_COUNTRY_2: 'Belize',
    TRIAL_FORM_COUNTRY_3: 'Bolivia',
    TRIAL_FORM_COUNTRY_4: 'Brazil',
    TRIAL_FORM_COUNTRY_5: 'Chile',
    TRIAL_FORM_COUNTRY_6: 'Colombia',
    TRIAL_FORM_COUNTRY_7: 'Costa Rica',
    TRIAL_FORM_COUNTRY_8: 'Cuba',
    TRIAL_FORM_COUNTRY_9: 'Ecuador',
    TRIAL_FORM_COUNTRY_10: 'El Salvador',
    TRIAL_FORM_COUNTRY_12: 'Spain',
    TRIAL_FORM_COUNTRY_13: 'United States of America',
    TRIAL_FORM_COUNTRY_14: 'Guatemala',
    TRIAL_FORM_COUNTRY_15: 'Honduras',
    TRIAL_FORM_COUNTRY_16: 'Mexico',
    TRIAL_FORM_COUNTRY_17: 'Nicaragua',
    TRIAL_FORM_COUNTRY_18: 'Panama',
    TRIAL_FORM_COUNTRY_19: 'Paraguay',
    TRIAL_FORM_COUNTRY_20: 'Peru',
    TRIAL_FORM_COUNTRY_21: 'Puerto Rico',
    TRIAL_FORM_COUNTRY_22: 'Dominican Republic',
    TRIAL_FORM_COUNTRY_23: 'Uruguay',
    TRIAL_FORM_COUNTRY_24: 'Venezuela',
    TRIAL_FORM_COUNTRY_25: 'Other',

    TRIAL_FORM_COMPANY_SIZE_1: 'Up to 150 people',
    TRIAL_FORM_COMPANY_SIZE_2: 'From 151 to 1000 people',
    TRIAL_FORM_COMPANY_SIZE_3: 'From 1001 to 5000 people',
    TRIAL_FORM_COMPANY_SIZE_4: '5001 people and more',

    CONFIRMATION_DIALOG_TITLE: 'Thank you for \n registering your data',
    CONFIRMATION_DIALOG_DESCRIPTION:
      'We will be contacting you shortly \n so you can experience this.',
    CONFIRMATION_DIALOG_BUTTON: 'Finish',

    SUCESS_DIALOG_TITLE: 'Thank you for registering your data!',
    SUCCESS_DIALOG_TITLE_DOWNLOADABLE: 'You can now download your content!',
    SUCCESS_DIALOG_CTA_DOWNLOADABLE: 'Download',
    SUCESS_DIALOG_BODY:
      'Soon an advisor will contact you to provide more information.',
    SUCESS_DIALOG_BUTTON: 'Understood',

    LOADER_FINAL_STEP_TITLE:
      'Thank you very much {{name}} for registering your data!',
    LOADER_FINAL_STEP_1: 'Analyzing the characteristics of your company',
    LOADER_FINAL_STEP_2:
      'Contacting you with the best advisor according to your needs',
    LOADER_FINAL_STEP_3: 'Building a proposal of Plans for Teams',
    LOADER_FINAL_STEP_4: 'Building learning paths according to your industry',

    FORM_BY_STEPS_NAME_LABEL: 'First Name',
    FORM_BY_STEPS_NAME_HINT: 'Type your first name',
    FORM_BY_STEPS_LASTNAME_LABEL: 'Last Name',
    FORM_BY_STEPS_LASTNAME_HINT: 'Type your last name',
    FORM_BY_STEPS_NEXT_BUTTON: 'Continue',
    FORM_BY_STEPS_COUNTRY_LABEL: 'Country',
    FORM_BY_STEPS_COUNTRY_HINT: 'Select a country',
    FORM_BY_STEPS_EMAIL_LABEL: 'Corporate Email',
    FORM_BY_STEPS_EMAIL_HINT: 'Type your corporate email ',
    FORM_BY_STEPS_EMAIL_ERROR: 'Enter a valid email address',
    FORM_BY_STEPS_COMPANY_LABEL: 'Company',
    FORM_BY_STEPS_COMPANY_HINT: 'Type your company name',
    FORM_BY_STEPS_ROLE_LABEL: 'Position or Role',
    FORM_BY_STEPS_ROLE_HINT: 'Type your position or role',
    FORM_BY_STEPS_PHONE_LABEL: 'Phone Number',
    FORM_BY_STEPS_BANNER_ERROR: 'There was an error sending.',
    FORM_BY_STEPS_DEMO_REQUEST:
      'I want to receive a personalized demo of Crehana for Business',
    FORM_BY_STEPS_PROMOTION:
      'I want to receive promotions and news from Crehana for Business',

    LOADER_FINAL_COUNT_TITLE: 'Ready',

    FORM_STEPS_CONTEXT_1: 'Hello, I am Carolina, to start what is your name?',
    FORM_STEPS_CONTEXT_2: 'Great! Where are you from?',
    FORM_STEPS_CONTEXT_3: "We're doing great! What is your corporate email?",
    FORM_STEPS_CONTEXT_4:
      "Let's talk about your organization. What is your company's name?",
    FORM_STEPS_CONTEXT_5: 'Excellent! Tell me about your company size.',
    FORM_STEPS_CONTEXT_6: 'A few last details. What is your position or role?',
    FORM_STEPS_CONTEXT_7: 'What department do you work in?',
    FORM_STEPS_CONTEXT_8: 'To finish. What is your phone number?',

    VALIDATIONS_REQUIRED: 'Required field',
    VALIDATIONS_MAX_LENGTH: 'Maximum {{max}} characters',

    NAME_LABEL: 'First Name',
    REQUIRED_FIELD: 'Required field',
    REQUIRED_NAME: 'Required name',
    INVALID_NAME: 'Invalid name',
    LAST_NAME_LABEL: 'Last Name',
    REQUIRED_LAST_NAME: 'Required last name',
    INVALID_LAST_NAME: 'Invalid last name',

    //  step completed
    STEP_COMPLETED_TITLE: 'You requested a demo trial',
    STEP_COMPLETED_SUB_TITLE:
      'An advisor will contact you to help you and provide more information.',
    STEP_COMPLETED_CTA_LABEL: 'Understood',

    // User departments
    USER_DEPARTMENT_HINT: 'Select an option',
    USER_DEPARTMENT_LABEL: 'Work area',
    //
    USER_DEPARTMENT_HR: 'Human Resources',
    USER_DEPARTMENT_INNOVATION_IT: 'Innovation',
    USER_DEPARTMENT_MARKETING: 'Marketing',
    USER_DEPARTMENT_MANAGEMENT: 'Administration',
    USER_DEPARTMENT_SALES: 'Sales',
    USER_DEPARTMENT_TI: 'IT',
    USER_DEPARTMENT_OPERATIONS: 'Operations',
    USER_DEPARTMENT_FINANCES: 'Finances',
    USER_DEPARTMENT_OTHER: 'Other',

    // User roles
    USER_ROLE_HINT: 'Select an option',
    USER_ROLE_LABEL: 'Work position',
    //
    USER_ROLE_CEO: 'CEO/General Manager',
    USER_ROLE_C_LEVEL: 'C Level/Manager',
    USER_ROLE_VP: 'Vice President',
    USER_ROLE_MANAGER: 'Manager',
    USER_ROLE_FOUNDER: 'Founder',
    USER_ROLE_DIRECTOR: 'Director',
    USER_ROLE_COORDINATOR: 'Coordinator',
    USER_ROLE_EXECUTIVE: 'Executive',
    USER_ROLE_ANALIST: 'Analyst',
    USER_ROLE_INTERN: 'Intern',
    USER_ROLE_FREELANCE: 'Freelancer',
    USER_ROLE_STUDENT: 'Student',
    USER_ROLE_OTHER: 'Other',
  },
};

export default localeEn;
